import StoreLocator from '../../components/StoreLocator';

StoreLocator();
